export const tiktokMenu = [
  {
    path: "/tiktok",
    name: "tiktokParent",
    redirect: "/tiktok/brands",
    icon: "film",
    meta: {
      title: "TikTok",
      parentMenu: true,
      ability: {
        action: ["create", "read"],
        subject: ["TikTok", "TikTokUploader"],
      },
    },
    children: [
      {
        path: "/tiktok/brands",
        name: "tiktok-brands",
        icon: "list",
        component: () => import("@/views/tiktok/brands/TikTokBrandsList.vue"),
        meta: {
          title: "Brands",
          ability: { action: "create", subject: "TikTok" },
        },
      },
      {
        path: "/tiktok/keywords",
        name: "tiktok-keywords",
        icon: "hash",
        component: () =>
          import("@/views/tiktok/keywords/TikTokKeywordsList.vue"),
        meta: {
          title: "Keywords",
          ability: { action: "create", subject: "TikTok" },
        },
      },
      {
        path: "/tiktok/creators",
        name: "tiktok-creators",
        icon: "message-circle",
        component: () =>
          import("@/views/tiktok/creators/TikTokCreatorsList.vue"),
        meta: {
          title: "Creators",
          ability: { action: "create", subject: "TikTok" },
        },
      },
      {
        path: "/tiktok/report-uploader",
        name: "tiktok-report-uploader",
        icon: "pie-chart",
        component: () =>
          import("@/views/tiktok/reportUploader/TikTokReportUploaderList.vue"),
        meta: {
          title: "Report Uploader",
          ability: { action: "read", subject: "TikTokUploader" },
        },
      },
    ],
  },
];

export const tiktok = [
  {
    path: "/tiktok/brands",
    name: "tiktok-brands",
    component: () => import("@/views/tiktok/brands/TikTokBrandsList.vue"),
    meta: {
      title: "TikTok Brands List",
      ability: { action: "create", subject: "TikTok" },
    },
  },
  {
    path: "/tiktok/brands/:id",
    name: "tiktok-brand-info",
    component: () => import("@/views/tiktok/brands/TikTokBrandInfo.vue"),
    meta: {
      title: "TikTok Brand Info",
      ability: { action: "create", subject: "TikTok" },
    },
  },
  {
    path: "/tiktok/keywords",
    name: "tiktok-keywords",
    component: () => import("@/views/tiktok/keywords/TikTokKeywordsList.vue"),
    meta: {
      title: "TikTok Keywords List",
      ability: { action: "create", subject: "TikTok" },
    },
  },
  {
    path: "/tiktok/creators",
    name: "tiktok-creators",
    component: () => import("@/views/tiktok/creators/TikTokCreatorsList.vue"),
    meta: {
      title: "TikTok Creators List",
      ability: { action: "create", subject: "TikTok" },
    },
  },
  {
    path: "/tiktok/report-uploader",
    name: "tiktok-report-uploader",
    component: () =>
      import("@/views/tiktok/reportUploader/TikTokReportUploaderList.vue"),
    meta: {
      title: "TikTok Report Uploader",
      ability: { action: "read", subject: "TikTokUploader" },
    },
  },
  {
    path: "/tiktok/report-uploader/:type/upload",
    name: "tiktok-report-uploader-page",
    component: () =>
      import("@/views/tiktok/reportUploader/TikTokReportUploaderInfo.vue"),
    meta: {
      title: "TikTok Report Uploader",
      ability: { action: "create", subject: "TikTokUploader" },
    },
  },
];
